import React, { useCallback, useState } from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { API_BASE_URL } from '../api';
import InvoicePayView from '../components/portal/InvoicePayView';
import PublicBrandHeader from '../components/public/PublicBrandHeader';
import PublicBrandShell from '../components/public/PublicBrandShell';

export default function PortalInvoiceDetail() {
  const { token, invoiceId } = useParams();
  const [brand, setBrand] = useState(null);

  const fetchInvoice = useCallback(async () => {
    const res = await fetch(`${API_BASE_URL}public/client-portal/${token}/invoices/${invoiceId}`, {
      headers: { Accept: 'application/json' },
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(json.message || `HTTP ${res.status}`);
    if (json.brand) setBrand(json.brand);
    return json;
  }, [token, invoiceId]);

  const onCheckout = useCallback(
    async (successUrl, cancelUrl) => {
      const res = await fetch(
        `${API_BASE_URL}public/client-portal/${token}/invoices/${invoiceId}/checkout`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ success_url: successUrl, cancel_url: cancelUrl }),
        }
      );
      const json = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(json.message || `HTTP ${res.status}`);
      return json;
    },
    [token, invoiceId]
  );

  return (
    <PublicBrandShell embeddedBrand={brand}>
    <Box sx={{ maxWidth: 720, mx: 'auto', p: { xs: 2, md: 4 } }}>
      <PublicBrandHeader subtitle="Pay invoice" compact />
      <Button
        component={RouterLink}
        to={`/public/client/${token}`}
        startIcon={<ArrowBackIcon />}
        sx={{ mb: 2, textTransform: 'none' }}
      >
        Back to portal
      </Button>
      <InvoicePayView fetchInvoice={fetchInvoice} onCheckout={onCheckout} compact />
    </Box>
    </PublicBrandShell>
  );
}
